import _ from 'lodash'
import {ICategorical} from '@/utils/media'
import {IWordProps, Word} from './word'
import {IFieldDescriptor} from '@/features/mixer'

export interface ICategoricalsProps {
  data?: {[key: string]: ICategorical | string[]}
  range?: {min: number; max: number}
  wordProps?: Partial<IWordProps> | ((field: IFieldDescriptor) => Partial<IWordProps> | undefined)
  sourcePath?: (kind: string, word: string) => string | undefined
}

const defaultSourcePathFn = (kind: string, word: string) =>
  kind !== undefined ? `${kind}["${word}"]` : word

export function Categoricals(props: ICategoricalsProps) {
  const {data, range, wordProps, sourcePath} = {
    range: {min: 0, max: 1},
    sourcePath: defaultSourcePathFn,
    ...props,
  }

  return (
    <div className='categoricals'>
      {_.chain(data)
        .toPairs()
        .map(([k, v]) => {
          const words: [string, number | undefined][] =
            _.isArray(v) ? _.map(v, (vv) => [vv, undefined]) : _.toPairs(v)
          return (
            <div
              className='category'
              key={k}
            >
              <div className='title'>{k}</div>
              <div className='content'>
                {_.chain(words)
                  .map(([kk, vv]) => {
                    const _sourcePath = sourcePath(k, kk) || defaultSourcePathFn(k, kk)
                    const descriptor: IFieldDescriptor = {
                      kind: k,
                      range,
                      word: kk,
                      label: `${k}: ${kk}`,
                      sourcePath: _sourcePath,
                    }
                    const _wordProps = _.isFunction(wordProps) ? wordProps(descriptor) : wordProps
                    return (
                      <Word
                        key={kk}
                        label={kk}
                        descriptor={descriptor}
                        value={vv}
                        // range={range}
                        {..._wordProps}
                      />
                    )
                  })
                  .value()}
              </div>
            </div>
          )
        })
        .value()}
    </div>
  )
}
